'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import VideoTextCard from '@/components/VideoTextCard';
import card2Data from '../../../textContent/retail/cardTwo.json';
import card3Data from '../../../textContent/retail/cardThree.json';
import cardData from '../../../textContent/retail/cardOne.json';
import { motion } from 'framer-motion';

/* ---------------- Animation Variants ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const Page = () => {
    const heroText = {
        heading: 'From Retail Chaos to Cashflow Nirvana',
        caption:
            'No matter your retail size or specialty, We have the tools to unleash your inner beast and turn your business into a cashflow symphony.',
        buttonText: 'Talk To Sales',
        buttonLink: '/contact-sales',
        image: '/images/hero/sales-dash.png',
    };

    return (
        <Fragment>
            {/* Hero */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <Hero {...heroText} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
            >
                <VideoTextCard data={cardData} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
            >
                <VideoTextCard data={card2Data} />
            </motion.div>

            {/* Card 3 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
            >
                <VideoTextCard data={card3Data} />
            </motion.div>
        </Fragment>
    );
};

export default Page;
